<template>
  <header class="Header">
    <div class="Header-container">
      <p class="Header-topLineSmall">Back Office</p>
      <p class="Header-topLineBig">CHANEL & Moi Digital Passport</p>
    </div>
  </header>
</template>

<script lang="ts" setup>
</script>

<style scoped lang="scss">
@import "~@/scss/_variables.scss";

.Header {
  border-bottom: solid $grey 1px;
  flex-basis: 5rem;
  background-color: $themePrimaryColor;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;

  &-container {
    color: $themeSecondaryColor;
    text-align: center;
  }

  &-topLineSmall {
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-family: $fontAbChanel;
  }

  &-topLineBig {
    font-family: $fontAbChanel;
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
</style>
